// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__xOPRQ","userName":"styles_userName__3M_vy"};